export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAYAAABytg0kAAAAAXNSR0IArs4c6QAAABRJREFUGFdjZFjXcpiBgYGBEcYAACkcA+11YrGyAAAAAElFTkSuQmCC"